import type { LayoutProps } from "@/features/companyDetail/types"
import type { PagesRouterPage } from "@/types"
import type { PropsWithChildren } from "react"

import { Layout } from "@/features/companyDetail/components/Layout/Layout"
import { Teams } from "@/features/companyDetail/components/Teams/Teams/Teams"

export const PageContent: PagesRouterPage<PropsWithChildren<LayoutProps>> = props => {
  return (
    <Layout {...props}>
      <Teams />
    </Layout>
  )
}
